var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError, resolveQueryFieldsTransformationPaths, } from '@wix/metro-runtime/velo';
import * as ambassadorWixFormsV4FormSpamSubmissionReport from '@wix/ambassador-forms-v4-form-spam-submission-report/http';
// @ts-ignore
import { wrapWithQueryBuilder } from '@wix/motion-edm-autogen-query-wrapper';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var ReportReason;
(function (ReportReason) {
    ReportReason["UNKNOWN_REASON"] = "UNKNOWN_REASON";
    /** An email quota is reached. There were too many submissions in a short time period with the same email. */
    ReportReason["EMAIL_QUOTA_REACHED"] = "EMAIL_QUOTA_REACHED";
    /** An IP address is is blocklisted. */
    ReportReason["IP_BLOCKLISTED"] = "IP_BLOCKLISTED";
    /** An email is is blocklisted. */
    ReportReason["EMAIL_BLOCKLISTED"] = "EMAIL_BLOCKLISTED";
    /** Reported spam by the AI spam detection model. It uses submission text as an input. */
    ReportReason["AI_REPORTED"] = "AI_REPORTED";
    /** Reported as spam by a submission manager. */
    ReportReason["MANUALLY_REPORTED"] = "MANUALLY_REPORTED";
})(ReportReason || (ReportReason = {}));
export var SubmissionStatus;
(function (SubmissionStatus) {
    SubmissionStatus["UNKNOWN_SUBMISSION_STATUS"] = "UNKNOWN_SUBMISSION_STATUS";
    SubmissionStatus["PENDING"] = "PENDING";
    SubmissionStatus["CONFIRMED"] = "CONFIRMED";
    SubmissionStatus["PAYMENT_WAITING"] = "PAYMENT_WAITING";
    SubmissionStatus["PAYMENT_CANCELED"] = "PAYMENT_CANCELED";
})(SubmissionStatus || (SubmissionStatus = {}));
export var OptInLevel;
(function (OptInLevel) {
    OptInLevel["SINGLE_CONFIRMATION"] = "SINGLE_CONFIRMATION";
    OptInLevel["DOUBLE_CONFIRMATION"] = "DOUBLE_CONFIRMATION";
})(OptInLevel || (OptInLevel = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
const _bulkDeleteFormSpamSubmissionReportByFilterRequest = {};
const _bulkDeleteFormSpamSubmissionReportByFilterResponse = {};
const _bulkDeleteFormSpamSubmissionReportRequest = {};
const _bulkDeleteFormSpamSubmissionReportResponse = {};
const _bulkReportNotSpamSubmissionRequest = {};
const _bulkReportNotSpamSubmissionResponse = {};
const _bulkReportSpamSubmissionRequest = {};
const _bulkReportSpamSubmissionResponse = {};
const _checkForSpamRequest = {};
const _checkForSpamResponse = {};
const _countFormSpamSubmissionReportsRequest = {};
const _countFormSpamSubmissionReportsResponse = {};
const _createFormSpamSubmissionReportRequest = {};
const _createFormSpamSubmissionReportResponse = {};
const _deleteFormSpamSubmissionReportRequest = {};
const _deleteFormSpamSubmissionReportResponse = {};
const _getFormSpamSubmissionReportRequest = {};
const _getFormSpamSubmissionReportResponse = {};
const _queryFormSpamSubmissionReportsByNamespaceRequest = {};
const _queryFormSpamSubmissionReportsByNamespaceResponse = {};
const _reportNotSpamSubmissionRequest = {};
const _reportNotSpamSubmissionResponse = {};
const _reportSpamSubmissionRequest = {};
const _reportSpamSubmissionResponse = {};
/**
 * Checks if submission is a spam.
 * @param submission - Form submission.
 * @public
 * @documentationMaturity preview
 * @requiredField submission
 * @requiredField submission.formId
 */
export function checkForSpam(submission) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { submission: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _checkForSpamRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _checkForSpamResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([submission]);
        const reqOpts = ambassadorWixFormsV4FormSpamSubmissionReport.checkForSpam(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'submission',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Creates a new spam submission.
 * To upload submission media, use the FormSubmissionService.getMediaUploadUrl endpoint.
 * @param formSpamSubmissionReport - Form spam submission report to be created.
 * @public
 * @documentationMaturity preview
 * @requiredField formSpamSubmissionReport
 * @requiredField formSpamSubmissionReport.formId
 * @requiredField formSpamSubmissionReport.reportReason
 * @requiredField formSpamSubmissionReport.submissions
 * @requiredField formSpamSubmissionReport.submitter
 * @adminMethod
 * @returns The created form spam submission report.
 */
export function createFormSpamSubmissionReport(formSpamSubmissionReport) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { formSpamSubmissionReport: '$[0]' };
        const responseTransformation = '$.formSpamSubmissionReport';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _createFormSpamSubmissionReportRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['formSpamSubmissionReport']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _createFormSpamSubmissionReportResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['formSpamSubmissionReport']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([formSpamSubmissionReport]);
        const reqOpts = ambassadorWixFormsV4FormSpamSubmissionReport.createFormSpamSubmissionReport(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'formSpamSubmissionReport',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Get a spam submission by id.
 * @param formSpamSubmissionReportId - Id of the form spam submission report to retrieve.
 * @public
 * @documentationMaturity preview
 * @requiredField formSpamSubmissionReportId
 * @adminMethod
 * @returns The retrieved form spam submission report.
 */
export function getFormSpamSubmissionReport(formSpamSubmissionReportId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { formSpamSubmissionReportId: '$[0]' };
        const responseTransformation = '$.formSpamSubmissionReport';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getFormSpamSubmissionReportRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getFormSpamSubmissionReportResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['formSpamSubmissionReport']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([formSpamSubmissionReportId]);
        const reqOpts = ambassadorWixFormsV4FormSpamSubmissionReport.getFormSpamSubmissionReport(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'formSpamSubmissionReportId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Delete a spam submission report.
 * @param formSpamSubmissionReportId - Id of the form spam submission report to delete.
 * @public
 * @documentationMaturity preview
 * @requiredField formSpamSubmissionReportId
 * @adminMethod
 */
export function deleteFormSpamSubmissionReport(formSpamSubmissionReportId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { formSpamSubmissionReportId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _deleteFormSpamSubmissionReportRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _deleteFormSpamSubmissionReportResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([formSpamSubmissionReportId]);
        const reqOpts = ambassadorWixFormsV4FormSpamSubmissionReport.deleteFormSpamSubmissionReport(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'formSpamSubmissionReportId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Deletes report by IDS or all for specific form.
 * @param formId - Form ID.
 * @public
 * @documentationMaturity preview
 * @requiredField formId
 * @adminMethod
 */
export function bulkDeleteFormSpamSubmissionReport(formId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            formId: '$[0]',
            formSpamSubmissionReportIds: '$[1].formSpamSubmissionReportIds',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _bulkDeleteFormSpamSubmissionReportRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _bulkDeleteFormSpamSubmissionReportResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([formId, options]);
        const reqOpts = ambassadorWixFormsV4FormSpamSubmissionReport.bulkDeleteFormSpamSubmissionReport(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'formId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Deletes reports by filter for specific form.
 * @param filter - Filter object.
 *
 * See [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) for more information.
 * @public
 * @documentationMaturity preview
 * @requiredField filter
 * @adminMethod
 */
export function bulkDeleteFormSpamSubmissionReportByFilter(filter) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { filter: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _bulkDeleteFormSpamSubmissionReportByFilterRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _bulkDeleteFormSpamSubmissionReportByFilterResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([filter]);
        const reqOpts = ambassadorWixFormsV4FormSpamSubmissionReport.bulkDeleteFormSpamSubmissionReportByFilter(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'filter',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Report a spam submission as not spam. The submission is created, and the spam report is deleted.
 * Submission automations are triggered the same way as in standard submission creation flow.
 * @param formSpamSubmissionReportId - Id of the form spam submission report to report as not spam.
 * @public
 * @documentationMaturity preview
 * @requiredField formSpamSubmissionReportId
 * @adminMethod
 */
export function reportNotSpamSubmission(formSpamSubmissionReportId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { formSpamSubmissionReportId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _reportNotSpamSubmissionRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _reportNotSpamSubmissionResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([formSpamSubmissionReportId]);
        const reqOpts = ambassadorWixFormsV4FormSpamSubmissionReport.reportNotSpamSubmission(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'formSpamSubmissionReportId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Report a spam submissions as not spam. The submissions is created, and the spam reports is deleted.
 * Submissions automations are triggered the same way as in standard submission creation flow.
 * @param formId - Id of the form to which belong reports
 * @public
 * @documentationMaturity preview
 * @requiredField formId
 * @adminMethod
 */
export function bulkReportNotSpamSubmission(formId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            formId: '$[0]',
            formSpamSubmissionReportIds: '$[1].formSpamSubmissionReportIds',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _bulkReportNotSpamSubmissionRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _bulkReportNotSpamSubmissionResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([formId, options]);
        const reqOpts = ambassadorWixFormsV4FormSpamSubmissionReport.bulkReportNotSpamSubmission(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'formId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Report a submission as spam. The spam submission report is created, and the submission is deleted.
 * @param submissionId - Id of the submission to report as spam.
 * @param reportReason - Identifies the reason why the submission was reported as spam.
 * @public
 * @documentationMaturity preview
 * @requiredField reportReason
 * @requiredField submissionId
 * @adminMethod
 */
export function reportSpamSubmission(submissionId, reportReason) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { submissionId: '$[0]', reportReason: '$[1]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _reportSpamSubmissionRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _reportSpamSubmissionResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['formSpamSubmissionReport']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([submissionId, reportReason]);
        const reqOpts = ambassadorWixFormsV4FormSpamSubmissionReport.reportSpamSubmission(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'submissionId',
                'reportReason',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Report multiple submissions as spam. The spam submission reports is created, and the submissions is deleted.
 * @param formId - Id of the form to which belong submissions to report as spam.
 * @public
 * @documentationMaturity preview
 * @requiredField formId
 * @requiredField options.reportReason
 * @requiredField options.submissionIds
 * @adminMethod
 */
export function bulkReportSpamSubmission(formId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            formId: '$[0]',
            submissionIds: '$[1].submissionIds',
            reportReason: '$[1].reportReason',
            returnEntity: '$[1].returnEntity',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _bulkReportSpamSubmissionRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _bulkReportSpamSubmissionResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#results.item']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([formId, options]);
        const reqOpts = ambassadorWixFormsV4FormSpamSubmissionReport.bulkReportSpamSubmission(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'formId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Query form spam submission reports using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
 * @public
 * @documentationMaturity preview
 * @permissionId WIX_FORMS.FORM_SPAM_SUBMISSION_REPORT_READ
 * @adminMethod
 */
export function queryFormSpamSubmissionReportsByNamespace() {
    const requestTransformation = { '*': '$[1]', query: '$[0]' };
    const responseTransformation = {
        items: '$.formSpamSubmissionReports',
        pagingMetadata: '$.pagingMetadata',
    };
    // @ts-ignore
    const { httpClient, sideEffects, additionalHeaders } = arguments[0];
    const { toAmbassadorRequest } = serializer({
        rootSchema: _queryFormSpamSubmissionReportsByNamespaceRequest,
        depSchemas: {},
        fqdnTransformation: {
            paths: [],
            transformation: _fromVeloEntity,
        },
        customTransformation: requestTransformation,
    });
    const { fromJSON } = serializer({
        rootSchema: _queryFormSpamSubmissionReportsByNamespaceResponse,
        depSchemas: {},
        fqdnTransformation: {
            paths: [...['Array#formSpamSubmissionReports']],
            transformation: _toVeloEntity,
        },
        customTransformation: responseTransformation,
    });
    return wrapWithQueryBuilder({
        func: (payload) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const reqOpts = ambassadorWixFormsV4FormSpamSubmissionReport.queryFormSpamSubmissionReportsByNamespace(payload);
            const reqOptionWithHeadersWrapper = (args) => {
                const result = reqOpts(args);
                if (additionalHeaders) {
                    const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                    return Object.assign(Object.assign({}, result), { headers });
                }
                return result;
            };
            (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
            try {
                const result = yield httpClient.request(reqOptionWithHeadersWrapper);
                (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
                return result;
            }
            catch (err) {
                (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
                throw err;
            }
        }),
        requestTransformer: (...args) => toAmbassadorRequest(args),
        responseTransformer: ({ data }) => fromJSON(data),
        errorTransformer: (err) => {
            const transformedError = transformError(err, requestTransformation);
            throw transformedError;
        },
        pagingMethod: 'CURSOR',
        transformationPaths: resolveQueryFieldsTransformationPaths(_toVeloEntity),
    })({ cursorWithEmptyFilterAndSort: true });
}
/**
 * Counts the number of spam submission reports belonging to the specified forms.
 * @param formIds - Form IDs.
 * @param namespace - Identifies the app which the form submissions belong to. For example, the namespace for the Wix Forms App is `"wix.form_app.form"`. The namespace of a submission can be retrieved using the Get Submission endpoint.
 * @public
 * @documentationMaturity preview
 * @requiredField formIds
 * @requiredField namespace
 * @adminMethod
 */
export function countFormSpamSubmissionReports(formIds, namespace) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { formIds: '$[0]', namespace: '$[1]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _countFormSpamSubmissionReportsRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _countFormSpamSubmissionReportsResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([formIds, namespace]);
        const reqOpts = ambassadorWixFormsV4FormSpamSubmissionReport.countFormSpamSubmissionReports(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'formIds',
                'namespace',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=forms-v4-form-spam-submission-report.universal.js.map